import Skeleton from 'react-loading-skeleton';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Heading from '../../../generic-components/Heading';
import { STYLES } from '../constants';

interface IProps {
    containerClassName: string;
    shouldShowHeader: boolean;
    categorizationType:string;
    containerHeader: string;
}

export const PreLoading = ({
  containerHeader, shouldShowHeader, containerClassName, categorizationType,
}: IProps) => {
  const { t } = useTranslation();
  return (
    <div className={containerClassName}>
      {shouldShowHeader && (
        <Heading
          title={containerHeader || `${t('CATEGORIZE_EXPENSES_COMPONENT_HEADER_PREFIX')} ${categorizationType.toLowerCase()}`}
          className={STYLES.MAIN_TITLE}
        />
      )}
      <div className='h-[300px] w-full flex flex-col items-center justify-center'>
        <Skeleton className='min-h-[260px] min-w-[200px] mb-[14px]' count={1} />
      </div>
    </div>
  );
};
